/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_FILTER_CONDITIONS = 'CHANGE_FILTER_CONDITIONS';
export const CHANGE_LOADING = 'CHANGE_LOADING';
export const CHANGE_EMBEDDED = 'CHANGE_EMBEDDED';
export const CHANGE_DIRTY = 'CHANGE_DIRTY';

/* WORKSPACE */
export const CHANGE_MERCHANT = 'CHANGE_MERCHANT';
export const CHANGE_BRANCH = 'CHANGE_BRANCH';
export const CHANGE_BRANCH_IDS = 'CHANGE_BRANCH_IDS';
export const CHANGE_SUBSCRIPTIONS = 'CHANGE_SUBSCRIPTIONS';
export const CHANGE_ASSIGNED_LICENSES = 'CHANGE_ASSIGNED_LICENSES';
export const CLEAR_WORKSPACE = 'CLEAR_WORKSPACE';
export const CHANGE_REPORT_FILTERS = 'CHANGE_REPORT_FILTERS';

/* AUTH */
export const LOGIN_USER_EMBEDDED = 'LOGIN_USER_EMBEDDED';
export const LOGIN_LOCAL_USER = 'LOGIN_LOCAL_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
export const BIND_MOBILE = 'BIND_MOBILE';
export const BIND_MOBILE_SUCCESS = 'BIND_MOBILE_SUCCESS';
export const BIND_MOBILE_ERROR = 'BIND_MOBILE_ERROR';
export const CHANGE_MOBILE = 'CHANGE_MOBILE';
export const CHANGE_MOBILE_SUCCESS = 'CHANGE_MOBILE_SUCCESS';
export const CHANGE_MOBILE_ERROR = 'CHANGE_MOBILE_ERROR';
export const CHANGE_NAME = 'CHANGE_MOBILE';
export const CHANGE_NAME_SUCCESS = 'CHANGE_MOBILE_SUCCESS';
export const CHANGE_NAME_ERROR = 'CHANGE_MOBILE_ERROR';
export const CHANGE_AVATAR = 'CHANGE_MOBILE';
export const CHANGE_AVATAR_SUCCESS = 'CHANGE_MOBILE_SUCCESS';
export const CHANGE_AVATAR_ERROR = 'CHANGE_MOBILE_ERROR';
export const CHANGE_ASSIGNMENTS = 'CHANGE_ASSIGNMENTS';
export const CHANGE_ROLES_PERMISSIONS = 'CHANGE_ROLES_PERMISSIONS';
export const LOGIN_USER_SSO = 'LOGIN_USER_SSO';
export const LOGIN_USER_SSO2 = 'LOGIN_USER_SSO2';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
	'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* OAUTH */
export const OAUTH_LOGIN_USER = 'OAUTH_LOGIN_USER';
export const OAUTH_LOGIN_USER_SUCCESS = 'OAUTH_LOGIN_USER_SUCCESS';
export const OAUTH_LOGIN_USER_ERROR = 'OAUTH_LOGIN_USER_ERROR';
export const OAUTH_SELECT_BRANCH = 'OAUTH_SELECT_BRANCH';
export const OAUTH_SELECT_BRANCH_SUCCESS = 'OAUTH_SELECT_BRANCH_SUCCESS';
export const OAUTH_SELECT_BRANCH_ERROR = 'OAUTH_SELECT_BRANCH_ERROR';
